import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {AuthenticationService} from './authentication.service';
import {djangourl} from '../../../assets/urls';
import {createWriteStream} from 'fs';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private handler: HttpBackend) {
  }

  http: HttpClient;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].indexOf(err.status) !== -1) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        // window.alert('لطفا دوباره وارد سایت شوید');
        this.authenticationService.logout();
        location.reload(true);

      }

      let username = '';
      let name = '';
      let details = '';
      try {
        username = this.authenticationService.currentUserValue.username;
        name = this.authenticationService.currentUserValue.first_name + ' ' + this.authenticationService.currentUserValue.last_name;

      } catch (e) {
         const error = err.message || err.statusText;
        return throwError(err);
      }

      try {
        details = JSON.stringify(err.error);
      } catch (e) {
        details = JSON.stringify(err);
      }
      this.http = new HttpClient(this.handler);
      this.http.post(djangourl + 'api/error/',
        {
          'error':

            '⚠️⚠️⚠️\n' +
            'url: ' + location + '\n' +
            'user: ' + username + '\n' +
            'name: ' + name + '\n\n' +
            'error status: ' + err.statusText + '\n' +
            'error message: ' + err.message + '\n\n\n' +
            'error details: \n' + details

        }
      ).subscribe(result => {
      });

      const error = err.message || err.statusText;
      return throwError(err);
    }));
  }
}
